import styled from 'styled-components';

const SettingsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: ${props =>
    props.direction ? props => props.direction : 'inherit'};
  height: ${props => (props.height ? props => props.height : 'auto')};

  @media screen and (max-width: 41.5625em) {
    height: auto;
    flex-direction: inherit;
  }
`;
export default SettingsGrid;
